const translations = {
  // Navigation
  "nav.home": "الرئيسية",
  "nav.about": "من نحن",
  "nav.services": "الخدمات",
  "nav.calendar": "التقويم",
  "nav.sermons": "العظات",
  "nav.resources": "الموارد",
  "nav.news": "الأخبار",
  "nav.contact": "اتصل بنا",
  "nav.donate": "تبرع",

  // Hero Section
  "hero.title": "القديس مينا والبابا كيرلس السادس",
  "hero.subtitle": "الكنيسة القبطية الأرثوذكسية",
  "hero.tagline": "متجذرون في إيمان قديم في عالم حديث",
  "hero.location": "نخدم الضفة الشمالية لمونتريال",
  "hero.joinUs": "انضم إلينا هذا الأحد",
  "hero.learnMore": "اعرف المزيد",

  // Liturgy Schedule
  "liturgy.sunday": "الأحد",
  "liturgy.wednesday": "الأربعاء",
  "liturgy.friday": "الجمعة",
  "liturgy.saturday": "السبت",
  "liturgy.satVespers": "عشية السبت",
  "liturgy.weeklySchedule": "الجدول الأسبوعي",
  "liturgy.divineLiturgyTimes": "مواعيد القداس الإلهي",
  "liturgy.joinEucharist": "انضم إلينا للإفخارستيا المقدسة طوال الأسبوع",
  "liturgy.divineLiturgy": "القداس الإلهي",
  "liturgy.saturdayEvening": "مساء السبت",
  "liturgy.vespersMidnight": "صلاة العشية وتسبحة نصف الليل",
  "liturgy.viewFullCalendar": "عرض التقويم الكامل",
  "liturgy.thisWeekLiturgies": "قداسات هذا الأسبوع",
  "liturgy.thisWeekSchedule": "جدول هذا الأسبوع",
  "liturgy.liveFromGoogleCalendar": "مباشر من تقويم جوجل",
  "liturgy.loadingSchedule": "جاري تحميل جدول القداسات…",
  "liturgy.time": "الوقت",
  "liturgy.language": "اللغة",
  "liturgy.location": "المكان",
  "liturgy.divineService": "خدمة إلهية",

  // Services Section
  "services.title": "خدماتنا",
  "services.subtitle": "انضم إلينا للعبادة والنمو الروحي والشركة",
  "services.confession": "الاعتراف",
  "services.confessionDesc": "الإرشاد الروحي والمصالحة",
  "services.sundaySchool": "مدارس الأحد",
  "services.sundaySchoolDesc": "التعليم الإيماني لجميع الأعمار",
  "services.preschoolCoptic": "القبطية للأطفال",
  "services.preschoolCopticDesc": "تعليم لغتنا المقدسة",
  "services.holyLiturgy": "القداس الإلهي",
  "services.holyLiturgyTime": "الأحد 8:00 – 11:30 صباحاً",
  "services.choir": "الكورال",
  "services.choirDesc": "الترانيم والألحان المقدسة",
  "services.bibleStudy": "دراسة الكتاب المقدس",
  "services.bibleStudyDesc": "عمّق إيمانك من خلال الكتاب المقدس",
  "services.viewFullSchedule": "عرض الجدول الكامل",

  // Church Leaders
  "leaders.title": "كنيستنا القبطية الأرثوذكسية",
  "leaders.subtitle": "بقيادة خدام أمناء مكرسين للإرشاد الروحي",
  "leaders.popeTawadros": "قداسة البابا تواضروس الثاني",
  "leaders.popeTawadrosTitle": "البابا الـ118 للإسكندرية وبطريرك كرسي القديس مرقس",
  "leaders.popeTawadrosDesc": "يقود قداسته الكنيسة القبطية الأرثوذكسية في جميع أنحاء العالم بحكمة وتكريس، مواصلاً الخلافة الرسولية من القديس مرقس.",
  "leaders.bishopBoulos": "نيافة الأنبا بولس",
  "leaders.bishopBoulosTitle": "أسقف إيبارشية أوتاوا ومونتريال وشرق كندا",
  "leaders.bishopBoulosDesc": "يخدم نيافته بتفانٍ ومحبة، مقدماً الإرشاد الروحي والرعاية الرعوية لمجتمعنا.",
  "leaders.fatherAnthony": "الأب أنطوني مايكل",
  "leaders.fatherAnthonyTitle": "كاهن كنيسة القديس مينا والبابا كيرلس السادس",
  "leaders.fatherAnthonyDesc": "يخدم الأب أنطوني رعيتنا بشفقة وتفانٍ، راعياً مجتمعنا بالإيمان والمحبة.",

  // Featured Sections
  "featured.recentSermons": "العظات الأخيرة",
  "featured.sermonsDesc": "استمع إلى رسائل ملهمة من رجال الدين لدينا",
  "featured.viewAllSermons": "عرض جميع العظات",
  "featured.upcomingEvents": "الفعاليات القادمة",
  "featured.eventsDesc": "انضم إلينا للشركة والأنشطة المجتمعية",
  "featured.viewAllEvents": "عرض جميع الفعاليات",
  "featured.photoGallery": "معرض الصور",
  "featured.galleryDesc": "الأيقونات المقدسة ولحظات المجتمع",
  "featured.viewGallery": "عرض المعرض",

  // CTA Section
  "cta.supportMission": "ادعم رسالتنا",
  "cta.supportDesc": "تساعدنا تبرعاتكم الكريمة على مواصلة خدمتنا وخدمة مجتمعنا",
  "cta.makeDonation": "قدم تبرعاً",

  // Footer
  "footer.quickLinks": "روابط سريعة",
  "footer.contact": "اتصل بنا",
  "footer.followUs": "تابعنا",
  "footer.rights": "جميع الحقوق محفوظة.",
  "footer.tagline": "متجذرون في الإيمان الأرثوذكسي القديم\u00a0نخدم الضفة الشمالية لمونتريال.",
  "footer.church": "الكنيسة",
  "footer.resources": "الموارد",
  "footer.connect": "تواصل",
  "footer.resourcesHub": "مركز الموارد",
  "footer.baptismForm": "طلب المعمودية",
  "footer.marriageForm": "طلب الزواج",
  "footer.funeralForm": "طلب الجنازة",
  "footer.eventBooking": "حجز الفعاليات",
  "footer.membershipForm": "العضوية",
  "footer.engagementForm": "طلب الخطوبة",
  "footer.privacyPolicy": "سياسة الخصوصية",
  "footer.termsOfService": "شروط الخدمة",
  "footer.copyright": "© 2026 كنيسة القديس مينا والبابا كيرلس السادس القبطية الأرثوذكسية. جميع الحقوق محفوظة.",

  // ── Home Page ──
  "home.seasonalPosts": "مقالات موسمية",
  "home.seasonalPostsDesc": "تأملات معمقة في مواسم واحتفالات السنة الليتورجية القبطية الأرثوذكسية",
  "home.currentlyObserving": "نحتفل حالياً",
  "home.daysRemaining": "أيام متبقية",
  "home.dayRemaining": "يوم متبقي",
  "home.nextFeast": "العيد القادم",
  "home.daysAway": "أيام متبقية",
  "home.dayAway": "يوم متبقي",
  "home.fastingSeason": "موسم الصوم",
  "home.holyWeek": "أسبوع الآلام",
  "home.upcomingFeast": "عيد قادم",
  "home.currentSeason": "الموسم الحالي",
  "home.liturgicalSeason": "موسم ليتورجي",
  "home.readFullArticle": "اقرأ المقال كاملاً",
  "home.viewAllNews": "عرض جميع الأخبار",
  "home.divineService": "خدمة إلهية",
  "home.time": "الوقت",
  "home.language": "اللغة",
  "home.location": "المكان",
  "home.viewFullCalendar": "عرض التقويم الكامل",
  "home.liveFromGoogleCalendar": "مباشر من تقويم جوجل",
  "home.loadingLiturgySchedule": "جاري تحميل جدول القداسات…",
  "home.thisWeekLiturgies": "قداسات هذا الأسبوع",
  "home.thisWeekSchedule": "جدول هذا الأسبوع",
  "home.close": "إغلاق",
  "home.openOnYouTube": "افتح على يوتيوب",
  "home.stayConnected": "ابق على تواصل",
  "home.followUsSocial": "تابعنا على وسائل التواصل",
  "home.socialDesc": "ابق على اتصال بأحدث لحظاتنا وتأملاتنا وأبرز أحداث المجتمع عبر جميع منصاتنا.",
  "home.spiritualGuidance": "الإرشاد الروحي",
  "home.liveStreaming": "البث المباشر",
  "home.sermonsDesc": "استمع إلى رسائل ملهمة وتعاليم من رجال الدين لدينا",
  "home.latest": "الأحدث",
  "home.viewAllOnYouTube": "عرض الكل على يوتيوب",
  "home.noSermonsAvailable": "لا توجد عظات متاحة حالياً.",
  "home.ourChurch": "كنيستنا القبطية الأرثوذكسية",
  "home.churchLeadersDesc": "بقيادة خدام أمناء مكرسين للإرشاد الروحي",
  "home.learnMoreAboutUs": "اعرف المزيد عنا",
  "home.subscribeNewsletter": "اشترك في نشرتنا البريدية للحصول على تحديثات عن الخدمات والفعاليات",
  "home.stayConnectedNewsletter": "ابق على تواصل",
  "home.monthlyNewsletter": "النشرة الشهرية",
  "home.viewAllNewsletters": "عرض جميع النشرات",
  "home.firstName": "الاسم الأول",
  "home.emailAddress": "البريد الإلكتروني",
  "home.subscribeBtn": "اشترك في النشرة",
  "home.subscribing": "جارٍ الاشتراك...",
  "home.subscribeSuccess": "شكراً لاشتراكك! ستتلقى تحديثاتنا قريباً.",
  "home.subscribeError": "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
  "home.privacyNote": "نحترم خصوصيتك. يمكنك إلغاء الاشتراك في أي وقت.",
  "home.ourServices": "خدماتنا",
  "home.servicesDesc": "تعرف على كيف تخدمك كنيستنا من خلال العبادة والتعليم والرعاية المجتمعية",
  "home.exploreServices": "استكشف خدماتنا",
  "home.moreComingSoon": "المزيد قريباً",
  "home.yourGenerosity": "كرمك يصنع فرقاً",
  "home.supportMission": "ادعم",
  "home.mission": "رسالتنا",
  "home.donateDesc": "تساعدنا تبرعاتكم الكريمة على مواصلة خدمتنا ودعم البرامج المجتمعية ونشر محبة الله.",
  "home.taxDeductible": "جميع التبرعات معفاة من الضرائب ومعالجة بشكل آمن",
  "home.giveNow": "تبرع الآن",
  "home.recurringGift": "إعداد تبرع متكرر",
  "home.securePayment": "دفع آمن",
  "home.sslEncrypted": "تشفير SSL",
  "home.taxReceipt": "إيصال ضريبي مقدم",
  "home.ministryPrograms": "برامج الخدمة",
  "home.ministryProgramsDesc": "دعم خدمات العبادة وبرامج الشباب ومبادرات النمو الروحي",
  "home.communityOutreach": "التواصل المجتمعي",
  "home.communityOutreachDesc": "مساعدة المحتاجين من خلال بنوك الطعام والملاجئ وخدمات الدعم",
  "home.missionWork": "العمل الإرسالي",
  "home.missionWorkDesc": "نشر الإنجيل وخدمة المجتمعات حول العالم",
  "home.ancientFaith": "إيمان قديم",
  "home.copticTradition": "التقليد القبطي",
  "home.montreal": "مونتريال",
  "home.copticHeritage": "تراثنا القبطي",
  "home.years2000": "أكثر من 2000 سنة",
  "home.apostolicChurch": "الكنيسة الرسولية",
  "home.livingTradition": "تقليد حي",
  "home.symbolOfFaith": "رمز إيماننا",
  "home.copticCross": "الصليب القبطي",
  "home.sacredTraditions": "تقاليدنا المقدسة",
  "home.divineLiturgy": "القداس الإلهي",
  "home.divineLiturgyDesc": "ليتورجيتنا التي ألفها القديس باسيليوس والقديس غريغوريوس تُحتفل بها دون تغيير منذ قرون. القداس الإلهي هو قلب العبادة القبطية.",
  "home.copticHymns": "الألحان القبطية",
  "home.copticHymnsDesc": "تقليدنا الموسيقي الفريد يحافظ على ألحان من موسيقى المعابد المصرية القديمة. هذه الترانيم المقدسة تخلق جواً روحياً عميقاً.",
  "home.fastingFeasts": "الأصوام والأعياد",
  "home.fastingFeastsDesc": "تحتفظ الكنيسة القبطية بأكثر من 210 يوماً من الصيام سنوياً. تقويمنا غني بالأعياد التي تحتفل بالعذراء مريم والقديسين.",
  "home.iconography": "الأيقونات",
  "home.iconographyDesc": "الأيقونات القبطية هي نوافذ إلى السماء، تصور المسيح والقديسين بالأسلوب البيزنطي المصري المميز.",
  "home.monasticism": "الرهبنة",
  "home.monasticismDesc": "مصر هي مهد الرهبنة المسيحية. أسس القديسان أنطونيوس وباخوميوس التقليد الرهباني الذي يلهم حياتنا الروحية.",
  "home.copticLanguage": "اللغة القبطية",
  "home.copticLanguageDesc": "اللغة القبطية، المرحلة الأخيرة من المصرية القديمة، محفوظة في ليتورجيتنا. تربطنا باللغة المنطوقة في مصر في زمن المسيح.",
  "home.loveCompassion": "المحبة والرحمة",
  "home.loveCompassionDesc": "اتباعاً لوصية المسيح بأن نحب بعضنا بعضاً، نظهر محبة الله من خلال أعمال اللطف والرحمة.",
  "home.community": "المجتمع",
  "home.communityDesc": "بناء علاقات ذات معنى متجذرة في الإيمان، في بيئة دافئة ومرحبة تكرم تراثنا القبطي.",
  "home.service": "الخدمة",
  "home.serviceDesc": "إحداث تأثير إيجابي من خلال برامج التوعية وخدمة المحتاجين، اقتداءً بمثال قديسينا الشفعاء.",
  "home.upcoming": "القادمة",
  "home.joinFellowship": "انضم إلينا في الشركة",
  "home.learnMore": "اعرف المزيد",
  "home.getInTouch": "تواصل معنا",
  "home.address": "العنوان",
  "home.phone": "الهاتف",
  "home.email": "البريد الإلكتروني",
  "home.officeHours": "ساعات العمل",
  "home.officeHoursValue": "الاثنين - الجمعة: 9:00 ص - 5:00 م\nالسبت: 10:00 ص - 2:00 م",
  "home.sendMessage": "إرسال الرسالة",
  "home.sending": "جارٍ الإرسال...",
  "home.thankYou": "شكراً لك! سنتواصل معك قريباً.",
  "home.namePlaceholder": "اسمك الكامل",
  "home.emailPlaceholder": "بريدك@مثال.com",
  "home.phonePlaceholder": "(555) 123-4567",
  "home.messagePlaceholder": "كيف يمكننا مساعدتك؟",
  "home.message": "الرسالة",
  "home.newsletter.january": "نشرة يناير",
  "home.newsletter.december": "نشرة ديسمبر",
  "home.newsletter.november": "نشرة نوفمبر",
  "home.newsletter.october": "نشرة أكتوبر",
  "home.newsletter.janDesc": "بركات العام الجديد والفعاليات القادمة والتحديثات",
  "home.newsletter.decDesc": "احتفالات عيد الميلاد ومراجعة العام والامتنان",
  "home.newsletter.novDesc": "تأملات الشكر وأبرز أحداث المجتمع",
  "home.newsletter.octDesc": "أنشطة الخريف وفرص الخدمة",
  "home.newsletter.janDate": "يناير 2025",
  "home.newsletter.decDate": "ديسمبر 2024",
  "home.newsletter.novDate": "نوفمبر 2024",
  "home.newsletter.octDate": "أكتوبر 2024",

  // ── Home Events Component ──
  "home.events.upcoming": "القادمة",
  "home.events.communityOutreach": "يوم التواصل المجتمعي",
  "home.events.communityOutreachDesc": "انضم إلينا في خدمة مجتمعنا المحلي من خلال توزيع الطعام وخدمات الدعم.",
  "home.events.youthGathering": "تجمع مجموعة الشباب",
  "home.events.youthGatheringDesc": "أنشطة ممتعة وعبادة وشركة للمراهقين والشباب.",
  "home.events.marriageWorkshop": "ورشة إثراء الزواج",
  "home.events.marriageWorkshopDesc": "قوِّ علاقتك بأدوات عملية وحكمة كتابية.",
  "home.events.movieNight": "ليلة فيلم عائلية",
  "home.events.movieNightDesc": "أحضر العائلة بأكملها لأمسية ممتعة مع الفشار والشركة.",
  "home.events.learnMore": "اعرف المزيد ←",

  // ── Home CopticCalendar Component ──
  "home.calendar.liturgicalSchedule": "الجدول الليتورجي",
  "home.calendar.thisWeek": "هذا الأسبوع في كنيستنا",
  "home.calendar.thisWeekDesc": "ابق على اتصال بخدماتنا الأسبوعية وأيام الأعياد والتجمعات المجتمعية",
  "home.calendar.sundayLiturgy": "قداس الأحد",
  "home.calendar.sundayLiturgyDesc": "القداس الإلهي كل أحد من 8:00 إلى 11:30 صباحاً مع ترانيم بالإنجليزية والعربية.",
  "home.calendar.saturdayVespers": "عشية السبت",
  "home.calendar.saturdayVespersDesc": "صلوات مسائية وتسبحة نصف الليل كل مساء سبت.",
  "home.calendar.bibleStudy": "دراسة الكتاب المقدس",
  "home.calendar.bibleStudyDesc": "دراسة كتابية أسبوعية ومناقشات روحية كل مساء أربعاء.",
  "home.calendar.viewFullCalendar": "عرض التقويم الكامل وأيام الأعياد",

  // ── Home AboutUs Component ──
  "home.about.copticHeritage": "تراثنا القبطي",
  "home.about.ancientFaith": "إيمان قديم",
  "home.about.copticTradition": "التقليد القبطي",
  "home.about.montreal": "مونتريال",
  "home.about.years2000": "أكثر من 2000 سنة",
  "home.about.apostolicChurch": "الكنيسة الرسولية",
  "home.about.livingTradition": "تقليد حي",
  "home.about.heritageIntro1": "تعود جذور الكنيسة القبطية الأرثوذكسية إلى القديس مرقس الرسول، الذي جلب المسيحية إلى مصر في القرن الأول الميلادي. لأكثر من 2000 عام، حافظت كنيستنا على الإيمان الرسولي القديم.",
  "home.about.heritageIntro2": "سميت كنيستنا باسم عمودين من الروحانية القبطية: القديس مينا، الشهيد صانع العجائب والحامي، والبابا كيرلس السادس، القديس الحديث المعروف بقداسته ومعجزاته.",
  "home.about.sacredTraditions": "تقاليدنا المقدسة",
  "home.about.divineLiturgy": "القداس الإلهي",
  "home.about.divineLiturgyDesc": "ليتورجيتنا التي ألفها القديس باسيليوس والقديس غريغوريوس تُحتفل بها دون تغيير منذ قرون. القداس الإلهي هو قلب العبادة القبطية.",
  "home.about.copticHymns": "الألحان القبطية",
  "home.about.copticHymnsDesc": "تقليدنا الموسيقي الفريد يحافظ على ألحان من موسيقى المعابد المصرية القديمة.",
  "home.about.fastingFeasts": "الأصوام والأعياد",
  "home.about.fastingFeastsDesc": "تحتفظ الكنيسة القبطية بأكثر من 210 يوماً من الصيام سنوياً. تقويمنا غني بالأعياد.",
  "home.about.iconography": "الأيقونات",
  "home.about.iconographyDesc": "الأيقونات القبطية هي نوافذ إلى السماء، تصور المسيح والقديسين بالأسلوب البيزنطي المصري المميز.",
  "home.about.monasticism": "الرهبنة",
  "home.about.monasticismDesc": "مصر هي مهد الرهبنة المسيحية. أسس القديسان أنطونيوس وباخوميوس التقليد الرهباني.",
  "home.about.copticLanguage": "اللغة القبطية",
  "home.about.copticLanguageDesc": "اللغة القبطية، المرحلة الأخيرة من المصرية القديمة، محفوظة في ليتورجيتنا.",
  "home.about.loveCompassion": "المحبة والرحمة",
  "home.about.loveCompassionDesc": "اتباعاً لوصية المسيح بأن نحب بعضنا بعضاً، نظهر محبة الله من خلال أعمال اللطف والرحمة.",
  "home.about.community": "المجتمع",
  "home.about.communityDesc": "بناء علاقات ذات معنى متجذرة في الإيمان، في بيئة دافئة ومرحبة.",
  "home.about.service": "الخدمة",
  "home.about.serviceDesc": "إحداث تأثير إيجابي من خلال برامج التوعية وخدمة المحتاجين.",

  // ── Home Contact Component ──
  "home.contact.getInTouch": "تواصل معنا",
  "home.contact.address": "العنوان",
  "home.contact.addressValue": "123 شارع الإيمان\nسبرينجفيلد، IL 62701",
  "home.contact.phone": "الهاتف",
  "home.contact.phoneValue": "(555) 123-4567",
  "home.contact.email": "البريد الإلكتروني",
  "home.contact.emailValue": "contact@smpcvi.ca",
  "home.contact.officeHours": "ساعات العمل",
  "home.contact.officeHoursValue": "الاثنين - الجمعة: 9:00 ص - 5:00 م\nالسبت: 10:00 ص - 2:00 م",
  "home.contact.name": "الاسم",
  "home.contact.namePlaceholder": "اسمك الكامل",
  "home.contact.emailPlaceholder": "بريدك@مثال.com",
  "home.contact.phonePlaceholder": "(555) 123-4567",
  "home.contact.message": "الرسالة",
  "home.contact.messagePlaceholder": "كيف يمكننا مساعدتك؟",
  "home.contact.sendMessage": "إرسال الرسالة",
  "home.contact.sending": "جارٍ الإرسال...",
  "home.contact.thankYou": "شكراً لك! سنتواصل معك قريباً.",
  "home.contact.privacyNote": "نحترم خصوصيتك ولن نشارك معلوماتك أبداً.",

  // ── About Page ──
  "aboutPage.title": "من نحن",
  "aboutPage.subtitle": "تعرف على كنيستنا وتاريخنا وإيماننا",
  "aboutPage.ourMission": "رسالتنا",
  "aboutPage.servingNorthShore": "نخدم الضفة الشمالية لمونتريال",
  "aboutPage.servingNorthShoreDesc1": "تأسست كنيسة القديس مينا والبابا كيرلس السادس القبطية الأرثوذكسية برسالة إلهية: خدمة الاحتياجات الروحية للمسيحيين الأرثوذكس في الضفة الشمالية لمونتريال.",
  "aboutPage.servingNorthShoreDesc2": "من خلال مباركة قداسة البابا تواضروس الثاني، نقدم الإيمان القبطي الأرثوذكسي القديم إلى هذه المنطقة.",
  "aboutPage.strategicLocation": "موقع استراتيجي",
  "aboutPage.strategicLocationDesc": "موقع مركزي في سانت تيريز لخدمة منطقة الضفة الشمالية بأكملها",
  "aboutPage.growingCommunity": "مجتمع متنامٍ",
  "aboutPage.growingCommunityDesc": "نرحب بالعائلات من لافال وبلينفيل وميرابيل وما بعدها",
  "aboutPage.ourServiceArea": "منطقة خدمتنا",
  "aboutPage.serviceAreaList": "لافال • سانت تيريز • بلينفيل • روزمير • بوا بريان • ميرابيل • تيربون • والمزيد",
  "aboutPage.ourJourney": "رحلتنا",
  "aboutPage.churchTimeline": "الجدول الزمني للكنيسة",
  "aboutPage.timelineDesc": "تأسست عام 2016 بمباركة قداسة البابا تواضروس الثاني، نمت كنيستنا من مجتمع صغير إلى بيت روحي مزدهر.",
  "aboutPage.viewTimeline": "عرض جدولنا الزمني",
  "aboutPage.hideTimeline": "إخفاء الجدول الزمني",
  "aboutPage.collapseTimeline": "طي الجدول الزمني",
  "aboutPage.yearsOfFaith": "ألفا سنة من الإيمان",
  "aboutPage.copticChurchTitle": "الكنيسة القبطية الأرثوذكسية",
  "aboutPage.copticChurchDesc": "واحدة من أقدم الكنائس المسيحية في العالم، أسسها القديس مرقس الإنجيلي في الإسكندرية، مصر",
  "aboutPage.churchFounded": "تأسيس الكنيسة",
  "aboutPage.faithfulWorldwide": "مؤمن حول العالم",
  "aboutPage.popesOfAlexandria": "باباوات الإسكندرية",
  "aboutPage.fastingDays": "أيام صيام بالسنة",
  "aboutPage.heavenlyIntercessors": "شفعاء سماويون",
  "aboutPage.patronSaints": "قديسونا الشفعاء",
  "aboutPage.patronSaintsDesc": "القديسون الذين يرشدون ويشفعون لمجتمع كنيستنا",
  "aboutPage.spiritualGuidance": "الإرشاد الروحي",
  "aboutPage.spiritualFathers": "آباؤنا الروحيون",
  "aboutPage.spiritualFathersDesc": "البابا والأسقف والكاهن الذين يرعون مجتمعنا في الإيمان",
  "aboutPage.churchBoard": "أعضاء مجلس الكنيسة",
  "aboutPage.churchBoardDesc": "خدام مخلصون يقودون إدارة رعيتنا",
  "aboutPage.ourMissionTitle": "رسالتنا",
  "aboutPage.ourMissionDesc": "إعلان إنجيل يسوع المسيح، والحفاظ على الإيمان الرسولي والتقاليد القبطية، وخدمة الاحتياجات الروحية للمسيحيين الأرثوذكس في الضفة الشمالية لمونتريال.",
  "aboutPage.ourVision": "رؤيتنا",
  "aboutPage.ourVisionDesc": "أن نكون منارة للإيمان المسيحي الأرثوذكسي على الضفة الشمالية، رعية نابضة بالحياة تغذي النمو الروحي وترحب بكل طالبي المسيح.",
  "aboutPage.missionCelebrate": "الاحتفال بالقداس الإلهي والأسرار المقدسة",
  "aboutPage.missionTeach": "تعليم وحفظ التقاليد القبطية الأرثوذكسية",
  "aboutPage.missionCommunity": "بناء مجتمع محب وداعم",
  "aboutPage.visionExpand": "توسيع مرافقنا لخدمة المزيد من العائلات",
  "aboutPage.visionYouth": "تطوير خدمات الشباب والعائلة",
  "aboutPage.visionOutreach": "تعزيز برامج التواصل المجتمعي",
  "aboutPage.joinFamily": "انضم إلى عائلة كنيستنا",
  "aboutPage.joinFamilyDesc": "ندعوك للعبادة معنا وأن تصبح جزءاً من مجتمعنا المتنامي",
  "aboutPage.viewServiceTimes": "عرض أوقات الخدمات",

  // ── About Page Timeline Events ──
  "aboutPage.timeline.2016.title": "البداية",
  "aboutPage.timeline.2016.desc": "بدأ المجتمع في التوسع في الضفة الشمالية لمونتريال، بناءً على طلب البابا تواضروس الثاني. أرسل الأب أنطوني لبدء الكنيسة. في أقل من شهر، وجدنا كنيسة للبيع وتمكنا من شرائها.",
  "aboutPage.timeline.2017.title": "بدء التجديدات",
  "aboutPage.timeline.2017.desc": "بدأت التجديدات في الطابق السفلي والكنيسة في الطابق العلوي، محولة المبنى إلى مكان جميل للعبادة.",
  "aboutPage.timeline.2018.title": "الذكرى العاشرة للأب أنطوني",
  "aboutPage.timeline.2018.desc": "احتفلنا بالذكرى العاشرة للأب أنطوني ككاهن، مكرمين خدمته المخلصة للكنيسة القبطية الأرثوذكسية.",
  "aboutPage.timeline.2019.title": "سيامة الأنبا بولس",
  "aboutPage.timeline.2019.desc": "قام البابا تواضروس الثاني بسيامة الأب بولس البراموسي أسقفاً لإيبارشية أوتاوا ومونتريال وشرق كندا.",
  "aboutPage.timeline.2024.title": "مشروع الأيقونسطاس",
  "aboutPage.timeline.2024.desc": "بدأ مشروع الأيقونسطاس للكنيسة، وهو حاجز مقدس مزين بالأيقونات لتعزيز عبادتنا الليتورجية.",
  "aboutPage.timeline.2025.title": "تجديد خارجي",
  "aboutPage.timeline.2025.desc": "بدأنا تجديد الجزء الخارجي من الكنيسة، تجميل المظهر الخارجي ليعكس مجد الله.",
  "aboutPage.timeline.2026.title": "الاحتفال بالذكرى العاشرة",
  "aboutPage.timeline.2026.desc": "نحتفل بالذكرى العاشرة لكنيستنا، عقد من الإيمان والنمو والخدمة لمجتمع الضفة الشمالية.",

  // ── About Page Coptic History ──
  "aboutPage.copticHistory.origins.title": "اسم \"مصر\" والتراث القبطي",
  "aboutPage.copticHistory.origins.era": "الأصول",
  "aboutPage.copticHistory.origins.desc": "كلمة \"قبطي\" تأتي من اليونانية \"إيجيبتوس\"، المشتقة من \"حا-كا-بتاح\" (بيت روح بتاح)، الاسم القديم لمنف. الأقباط هم المسيحيون الأصليون في مصر.",
  "aboutPage.copticHistory.stMark.title": "القديس مرقس الإنجيلي",
  "aboutPage.copticHistory.stMark.desc": "القديس مرقس، كاتب الإنجيل الثاني، جلب المسيحية إلى مصر حوالي عام 42 م. أسس كنيسة الإسكندرية ورسم أول أسقف.",
  "aboutPage.copticHistory.councils.title": "المجامع المسكونية واللاهوت",
  "aboutPage.copticHistory.councils.era": "المجامع",
  "aboutPage.copticHistory.councils.desc": "لعب اللاهوتيون الأقباط أدواراً حاسمة في المجامع الكنسية المبكرة. في نيقية (325 م)، دافع القديس أثناسيوس عن لاهوت المسيح.",
  "aboutPage.copticHistory.beliefs.title": "ما نؤمن به",
  "aboutPage.copticHistory.beliefs.era": "المعتقدات",
  "aboutPage.copticHistory.beliefs.desc": "نؤمن بإله واحد: الآب والابن والروح القدس. نعترف أن يسوع المسيح هو إله كامل وإنسان كامل، متحدان في طبيعة واحدة.",
  "aboutPage.copticHistory.traditions.title": "ما يميزنا",
  "aboutPage.copticHistory.traditions.era": "التقاليد",
  "aboutPage.copticHistory.traditions.desc": "تحافظ الكنيسة القبطية على اللغة القبطية في الليتورجيا. نحن مهد الرهبنة المسيحية. ليتورجيتنا وتقاليد صومنا بقيت دون تغيير لما يقرب من 2000 سنة.",
  "aboutPage.copticHistory.today.title": "إيمان قديم حي",
  "aboutPage.copticHistory.today.era": "اليوم",
  "aboutPage.copticHistory.today.desc": "اليوم، أكثر من 20 مليون قبطي حول العالم يواصلون هذا الإيمان الرسولي. من مصر إلى مونتريال، نحافظ على نفس الليتورجيا التي أسسها القديس مرقس.",

  // About Page Saints
  "aboutPage.saints.stMina.name": "القديس مينا العجائبي",
  "aboutPage.saints.stMina.title": "القديس الشفيع",
  "aboutPage.saints.stMina.desc": "شهيد مصري وصانع عجائب، من أكثر القديسين المحبوبين. سميت كنيستنا باسمه وأسست في يوم عيده.",
  "aboutPage.saints.stMina.feast": "24 نوفمبر",
  "aboutPage.saints.popeCyril.name": "البابا كيرلس السادس",
  "aboutPage.saints.popeCyril.title": "القديس الشفيع",
  "aboutPage.saints.popeCyril.desc": "البابا الـ116 للإسكندرية، المعروف بقداسته ومعجزاته وروحانيته العميقة. سميت كنيستنا باسمه.",
  "aboutPage.saints.popeCyril.feast": "9 مارس",

  // About Page Leadership
  "aboutPage.leadership.popeTawadros.name": "قداسة البابا تواضروس الثاني",
  "aboutPage.leadership.popeTawadros.title": "بابا الإسكندرية",
  "aboutPage.leadership.popeTawadros.desc": "البابا الـ118 للإسكندرية وبطريرك كرسي القديس مرقس. قداسته يقود الكنيسة القبطية الأرثوذكسية العالمية بحكمة ونعمة.",
  "aboutPage.leadership.bishopBoulos.name": "نيافة الأنبا بولس",
  "aboutPage.leadership.bishopBoulos.title": "أسقف أوتاوا ومونتريال وشرق كندا",
  "aboutPage.leadership.bishopBoulos.desc": "سيم نيافة الأنبا بولس البراموسي عام 2019 على يد البابا تواضروس الثاني ليشرف على إيبارشية أوتاوا ومونتريال وشرق كندا.",
  "aboutPage.leadership.frAnthony.name": "الأب أنطوني مايكل",
  "aboutPage.leadership.frAnthony.title": "كاهن الرعية",
  "aboutPage.leadership.frAnthony.desc": "يخدم الأب أنطوني ككاهن مخلص لكنيسة القديس مينا والبابا كيرلس السادس، راعياً مجتمعنا بمحبة منذ إرساله من البابا تواضروس الثاني عام 2016.",

  // Services Page
  "servicesPage.title": "خدمات العبادة",
  "servicesPage.subtitle": "انضم إلينا في العبادة والنمو الروحي",
  "servicesPage.whatWeOffer": "ما نقدمه",
  "servicesPage.ministriesPrograms": "الخدمات والبرامج",
  "servicesPage.ministriesDesc": "تقدم كنيستنا مجموعة متنوعة من الخدمات لمساعدتك على النمو في الإيمان وخدمة الآخرين.",
  "servicesPage.getInvolved": "انضم إلينا",
  "servicesPage.getInvolvedDesc": "ندعوك للانضمام إلى إحدى خدماتنا واستخدام مواهبك لخدمة الكنيسة والمجتمع.",
  "servicesPage.joinFormTitle": "انضم إلينا أو اطلب المزيد من المعلومات",
  "servicesPage.joinFormDesc": "اختر خدمة وسنتواصل معك.",
  "servicesPage.fullNameLabel": "الاسم الكامل",
  "servicesPage.yourName": "اسمك",
  "servicesPage.emailLabel": "البريد الإلكتروني",
  "servicesPage.youExample": "بريدك@مثال.com",
  "servicesPage.phoneLabel": "الهاتف",
  "servicesPage.serviceInterested": "الخدمة التي تهمني",
  "servicesPage.selectService": "اختر خدمة...",
  "servicesPage.messageOpt": "رسالة",
  "servicesPage.messageOptDesc": "أي أسئلة أو تفاصيل...",
  "servicesPage.maxChars": "الحد الأقصى 500 حرف",
  "servicesPage.submitRequest": "إرسال الطلب",

  // ── Services Detail Data ──
  "services.bibleStudy.title": "دراسة الكتاب المقدس",
  "services.bibleStudy.schedule": "كل سبت، 5:00 مساءً",
  "services.bibleStudy.location": "فصول الكنيسة",
  "services.bibleStudy.desc": "عمّق فهمك للكتاب المقدس من خلال جلسات دراسة الكتاب المقدس الأسبوعية. بقيادة رجال الدين والمعلمين ذوي الخبرة.",
  "services.bibleStudy.feature1": "دراسة آية بآية",
  "services.bibleStudy.feature2": "مناقشات جماعية",
  "services.bibleStudy.feature3": "جلسات أسئلة وأجوبة",
  "services.bibleStudy.feature4": "مواد دراسية مقدمة",

  "services.hymnsClass.title": "صف الألحان",
  "services.hymnsClass.schedule": "كل سبت، 7:00 مساءً",
  "services.hymnsClass.location": "فصول الكنيسة",
  "services.hymnsClass.desc": "تعلم الألحان القبطية الجميلة والقديمة المتوارثة عبر الأجيال. يعلم صف الألحان الألحان التقليدية والنطق والمعنى الروحي.",
  "services.hymnsClass.feature1": "تعليم اللغة القبطية",
  "services.hymnsClass.feature2": "الألحان التقليدية",
  "services.hymnsClass.feature3": "تاريخ ومعنى الألحان",
  "services.hymnsClass.feature4": "جميع المستويات مرحب بها",

  "services.sundaySchool.title": "مدارس الأحد",
  "services.sundaySchool.schedule": "كل أحد، 12:30 ظهراً",
  "services.sundaySchool.location": "فصول الكنيسة",
  "services.sundaySchool.desc": "يقدم برنامج مدارس الأحد تعليماً إيمانياً للأطفال والشباب من جميع الأعمار. من خلال الدروس والأنشطة الجذابة.",
  "services.sundaySchool.feature1": "فصول مناسبة للأعمار",
  "services.sundaySchool.feature2": "دروس تفاعلية",
  "services.sundaySchool.feature3": "أنشطة فنية وحرفية",
  "services.sundaySchool.feature4": "مسابقات سنوية",

  "services.youthMeeting.title": "اجتماع الشباب",
  "services.youthMeeting.schedule": "كل جمعة، 8:30 مساءً",
  "services.youthMeeting.location": "قبو الكنيسة",
  "services.youthMeeting.desc": "مجتمع نابض بالحياة للشباب للنمو في الإيمان معاً. يجمع اجتماع الشباب بين المناقشات الروحية وأنشطة الشركة وفرص الخدمة.",
  "services.youthMeeting.feature1": "مناقشات روحية",
  "services.youthMeeting.feature2": "أنشطة اجتماعية",
  "services.youthMeeting.feature3": "مشاريع خدمة",
  "services.youthMeeting.feature4": "خلوات ورحلات",

  "services.familyMeeting.title": "اجتماع العائلة",
  "services.familyMeeting.schedule": "كل جمعة، 8:30 مساءً",
  "services.familyMeeting.location": "ممر البابا كيرلس",
  "services.familyMeeting.desc": "قوِّ الروابط العائلية من خلال الإيمان مع اجتماع العائلة الشهري. يجتمع الآباء والأبناء للإرشاد الروحي والأنشطة العائلية.",
  "services.familyMeeting.feature1": "عبادة عائلية",
  "services.familyMeeting.feature2": "إرشاد للوالدين",
  "services.familyMeeting.feature3": "أنشطة للأطفال",
  "services.familyMeeting.feature4": "عشاء شركة",

  "services.seniorsMeeting.title": "اجتماع الكبار",
  "services.seniorsMeeting.schedule": "كل خميس، 11:00 صباحاً",
  "services.seniorsMeeting.location": "قاعة الرعية",
  "services.seniorsMeeting.desc": "تجمع عزيز لأعضائنا الكبار للاستمتاع بالشركة والإثراء الروحي والدعم المجتمعي. يشمل الصلاة ومناقشات الصحة والأنشطة الاجتماعية.",
  "services.seniorsMeeting.feature1": "صلاة وتكريس",
  "services.seniorsMeeting.feature2": "ندوات صحية",
  "services.seniorsMeeting.feature3": "أنشطة اجتماعية",
  "services.seniorsMeeting.feature4": "وجبة غداء مقدمة",

  "services.churchChoirs.title": "كورالات الكنيسة",
  "services.churchChoirs.schedule": "التدريب: السبت، 4:00 مساءً",
  "services.churchChoirs.location": "هيكل الكنيسة",
  "services.churchChoirs.desc": "تقود كورالات كنيستنا المصلين في العبادة المقدسة من خلال الألحان والردود القبطية الجميلة. لدينا كورالات لمختلف الفئات العمرية.",
  "services.churchChoirs.feature1": "كورال الكبار",
  "services.churchChoirs.feature2": "كورال الشباب",
  "services.churchChoirs.feature3": "كورال الأطفال",
  "services.churchChoirs.feature4": "المناسبات الخاصة",

  "services.theatreService.title": "خدمة المسرح",
  "services.theatreService.schedule": "عروض موسمية",
  "services.theatreService.location": "قاعة الكنيسة",
  "services.theatreService.desc": "خدمة المسرح لدينا تحيي الكتاب المقدس وسير القديسين من خلال عروض درامية قوية. يستخدم أعضاؤنا الموهوبون الفنون لإلهام الإيمان.",
  "services.theatreService.feature1": "مسرحيات كتابية",
  "services.theatreService.feature2": "دراما سير القديسين",
  "services.theatreService.feature3": "عروض الشباب",
  "services.theatreService.feature4": "إنتاجات الأعياد",

  "services.itMedia.title": "خدمات تكنولوجيا المعلومات والإعلام",
  "services.itMedia.schedule": "دعم مستمر",
  "services.itMedia.location": "غرفة الإعلام",
  "services.itMedia.desc": "يضمن فريق تكنولوجيا المعلومات والإعلام بقاء كنيستنا على اتصال مع المجتمع من خلال التكنولوجيا، من البث المباشر إلى إدارة وسائل التواصل.",
  "services.itMedia.feature1": "البث المباشر",
  "services.itMedia.feature2": "إدارة الموقع",
  "services.itMedia.feature3": "وسائل التواصل",
  "services.itMedia.feature4": "دعم الصوت والصورة",

  "services.kitchenServices.title": "خدمات المطبخ",
  "services.kitchenServices.schedule": "الأحد والمناسبات الخاصة",
  "services.kitchenServices.location": "مطبخ الكنيسة",
  "services.kitchenServices.desc": "يحضر فريق خدمات المطبخ وجبات للشركة بعد القداس والمناسبات الكنسية الخاصة. خدمة الضيافة هذه تجمع المجتمع حول المائدة.",
  "services.kitchenServices.feature1": "وجبات أغابي الأحد",
  "services.kitchenServices.feature2": "تقديم طعام للمناسبات",
  "services.kitchenServices.feature3": "خيارات قائمة الصوم",
  "services.kitchenServices.feature4": "فرص تطوعية",

  "services.holyBread.title": "خدمات الخبز المقدس",
  "services.holyBread.schedule": "السبت، الصباح الباكر",
  "services.holyBread.location": "غرفة تحضير الخبز",
  "services.holyBread.desc": "خدمة الخبز المقدس (القربان) هي خدمة مقدسة حيث يحضر المتطوعون الخبز المستخدم في التناول المقدس. يتطلب هذا التقليد القديم الصلاة والصوم والتكريس.",
  "services.holyBread.feature1": "تحضير مقدس",
  "services.holyBread.feature2": "أساليب تقليدية",
  "services.holyBread.feature3": "صلاة وألحان",
  "services.holyBread.feature4": "تدريب متاح",

  "services.cleaningServices.title": "خدمات التنظيف",
  "services.cleaningServices.schedule": "أسبوعياً وحسب الحاجة",
  "services.cleaningServices.location": "كامل حرم الكنيسة",
  "services.cleaningServices.desc": "يحافظ فريق خدمات التنظيف على جمال وقدسية بيت الله. يضمن هؤلاء المتطوعون المخلصون أن كنيستنا نظيفة ومرحبة.",
  "services.cleaningServices.feature1": "عناية بهيكل الكنيسة",
  "services.cleaningServices.feature2": "صيانة القاعات",
  "services.cleaningServices.feature3": "عناية بالأراضي",
  "services.cleaningServices.feature4": "تجهيز وتنظيف المناسبات",

  "services.homelessServices.title": "خدمات المشردين",
  "services.homelessServices.schedule": "خدمة شهرية",
  "services.homelessServices.location": "التواصل المجتمعي",
  "services.homelessServices.desc": "اتباعاً لدعوة المسيح لخدمة الأصغر بيننا، تقدم خدمة المشردين الطعام والملابس والدعم للمحتاجين. ننظم فعاليات تواصل منتظمة ونتعاون مع الملاجئ المحلية.",
  "services.homelessServices.feature1": "توزيع الطعام",
  "services.homelessServices.feature2": "حملات الملابس",
  "services.homelessServices.feature3": "شراكات مع الملاجئ",
  "services.homelessServices.feature4": "طرود رعاية",

  "services.libraryService.title": "خدمة المكتبة",
  "services.libraryService.schedule": "مفتوحة أيام الأحد وحسب الطلب",
  "services.libraryService.location": "مكتبة الكنيسة",
  "services.libraryService.desc": "تقدم مكتبة كنيستنا ثروة من الموارد الروحية تشمل كتباً عن اللاهوت الأرثوذكسي وسير القديسين والتاريخ القبطي ومواد الوسائط المتعددة.",
  "services.libraryService.feature1": "كتب لاهوتية",
  "services.libraryService.feature2": "قسم الأطفال",
  "services.libraryService.feature3": "موارد صوتية ومرئية",
  "services.libraryService.feature4": "مواد دراسية",

  // News Page
  "newsPage.title": "الأخبار",
  "newsPage.subtitle": "ابق على اطلاع بالفعاليات والمنشورات والنشرات من مجتمعنا",
  "newsPage.articles": "مقالات",
  "newsPage.events": "فعاليات",
  "newsPage.posts": "منشورات",
  "newsPage.newsletters": "نشرات",
  "newsPage.readMore": "اقرأ المزيد",
  "newsPage.monthlyNewsletters": "النشرات الشهرية",
  "newsPage.newslettersDesc": "حمل نشراتنا الشهرية للبقاء على اطلاع بأنشطة الكنيسة",
  "newsPage.downloadPDF": "تحميل PDF",
  "newsPage.newsletter1Title": "نشرة يناير",
  "newsPage.newsletter1Desc": "بركات العام الجديد والفعاليات القادمة والتحديثات",
  "newsPage.newsletter2Title": "نشرة ديسمبر",
  "newsPage.newsletter2Desc": "احتفالات عيد الميلاد ومراجعة العام والامتنان",
  "newsPage.newsletter3Title": "نشرة نوفمبر",
  "newsPage.newsletter3Desc": "تأملات الشكر وأبرز أحداث المجتمع",
  "newsPage.newsletter4Title": "نشرة أكتوبر",
  "newsPage.newsletter4Desc": "أنشطة الخريف وفرص الخدمة",
  "newsPage.subscribeNewsletter": "اشترك في نشرتنا البريدية",
  "newsPage.subscribeDesc": "تلقي التحديثات الشهرية مباشرة في صندوق الوارد",
  "newsPage.emailPlaceholder": "أدخل بريدك الإلكتروني",
  "newsPage.subscribe": "اشترك",
  "newsPage.viewAllOnInstagram": "عرض جميع المنشورات على إنستغرام",
  "newsPage.seasonalPosts": "مقالات موسمية",
  "newsPage.seasonalPostsDesc": "تأملات معمقة في مواسم واحتفالات السنة الليتورجية القبطية الأرثوذكسية",
  "newsPage.socialMedia": "وسائل التواصل",
  "newsPage.socialMediaDesc": "ابق على اتصال بأحدث لحظاتنا وتأملاتنا وأبرز أحداث المجتمع.",
  "newsPage.monthlyUpdates": "تحديثات شهرية",
  "newsPage.currentlyObserving": "نحتفل حالياً",
  "newsPage.currentSeason": "الموسم الحالي",
  "newsPage.nextFeast": "العيد القادم",
  "newsPage.nextFast": "الصوم القادم",
  "newsPage.days": "أيام",
  "newsPage.now": "الآن",
  "newsPage.fastingObserved": "صيام ملاحظ",
  "newsPage.backToArticles": "العودة إلى المقالات",
  "newsPage.fastingGuidelines": "إرشادات الصوم",
  "newsPage.exploreCalendar": "استكشف تقويم كنيستنا الكامل — الخدمات الأسبوعية وأيام الأعياد وفترات الصوم والمناسبات الخاصة على مدار السنة الليتورجية القبطية.",

  // Calendar Page
  "calendarPage.title": "التقويم",
  "calendarPage.subtitle": "أيام الأعياد وفترات الصوم والخدمات الأسبوعية",
  "calendarPage.weeklySchedule": "الجدول الأسبوعي",
  "calendarPage.thisWeekServices": "خدمات هذا الأسبوع",
  "calendarPage.weeklyScheduleDesc": "ابق على اتصال بخدماتنا الأسبوعية وأيام الأعياد والتجمعات المجتمعية",
  "calendarPage.liturgicalYear": "السنة الليتورجية",
  "calendarPage.feastDaysFasting": "أيام الأعياد والأصوام",
  "calendarPage.liturgicalYearDesc": "تتبع الكنيسة القبطية الأرثوذكسية تقويماً ليتورجياً قديماً غنياً بالأعياد والتذكارات وفترات الصوم المرعية منذ أكثر من 2000 سنة.",
  "calendarPage.tab.all": "الكل",
  "calendarPage.tab.major": "7 أعياد كبرى",
  "calendarPage.tab.minor": "7 أعياد صغرى",
  "calendarPage.tab.fast": "فترات الصوم",
  "calendarPage.stats.majorFeasts": "أعياد الرب الكبرى",
  "calendarPage.stats.minorFeasts": "أعياد الرب الصغرى",
  "calendarPage.stats.fastingDays": "أيام الصيام في السنة",
  "calendarPage.majorInfoTitle": "الأعياد السبع الكبرى",
  "calendarPage.majorInfoDesc": "هي أهم الاحتفالات في السنة الليتورجية القبطية. تحيي ذكرى الأحداث الرئيسية في حياة المسيح ويسبقها صوم واستعداد خاص.",
  "calendarPage.minorInfoTitle": "الأعياد السبع الصغرى",
  "calendarPage.minorInfoDesc": "تكمل الأعياد الكبرى بإحياء ذكرى أحداث هامة أخرى في حياة المسيح والعذراء مريم. تثري الحياة الروحية للمؤمنين طوال السنة.",
  "calendarPage.fastInfoTitle": "الصوم في الكنيسة القبطية",
  "calendarPage.fastInfoDesc": "هو من أقدم الممارسات المسيحية. تراعي الكنيسة القبطية الأرثوذكسية أكثر من 210 يوماً من الصيام سنوياً. يتضمن الصوم الامتناع عن جميع المنتجات الحيوانية.",
  "calendarPage.category.major": "عيد كبير",
  "calendarPage.category.minor": "عيد صغير",
  "calendarPage.category.fast": "فترة صوم",
  "calendarPage.spiritualSignificance": "الأهمية الروحية",
  "calendarPage.stayUpdated": "ابق على اطلاع",
  "calendarPage.stayUpdatedDesc": "تابع أحدث الأخبار والفعاليات والعظات وتحديثات المجتمع.",
  "calendarPage.goToNews": "اذهب إلى الأخبار",
  "calendarPage.viewFullCalendar": "عرض التقويم الكامل",
  "calendarPage.goToCalendar": "اذهب إلى التقويم",
  "calendarPage.aboutCopticCalendar": "عن التقويم القبطي",
  "calendarPage.calendarInfo": "يبدأ التقويم القبطي في 11 سبتمبر (النيروز) ويتكون من 13 شهراً. الأعياد المتحركة مثل القيامة تتبع التقويم اليولياني. التواريخ المعروضة بالتقويم الغريغوري.",

  // Contact Page
  "contactPage.title": "اتصل بنا",
  "contactPage.subtitle": "يسعدنا أن نسمع منك",
  "contactPage.getInTouch": "تواصل معنا",
  "contactPage.address": "العنوان",
  "contactPage.phone": "الهاتف",
  "contactPage.email": "البريد الإلكتروني",
  "contactPage.findUs": "موقعنا",
  "contactPage.name": "الاسم",
  "contactPage.namePlaceholder": "اسمك الكامل",
  "contactPage.emailPlaceholder": "بريدك@مثال.com",
  "contactPage.phonePlaceholder": "(514) 123-4567",
  "contactPage.message": "الرسالة",
  "contactPage.messagePlaceholder": "كيف يمكننا مساعدتك؟",
  "contactPage.sendMessage": "إرسال الرسالة",
  "contactPage.sending": "جارٍ الإرسال...",
  "contactPage.thankYou": "شكراً لك! سنتواصل معك قريباً.",
  "contactPage.privacyNote": "نحترم خصوصيتك ولن نشارك معلوماتك أبداً.",
  "contactPage.leadership": "القيادة",
  "contactPage.resourcesCTA": "استكشف مجموعتنا من نماذج الكنيسة والتطبيقات الرقمية والأجوبة على الأسئلة الشائعة ومواد المكتبة وأصول العلامة التجارية الرسمية.",
  "contactPage.goToResources": "اذهب إلى الموارد",

  // Donate Page
  "donatePage.title": "ادعم رسالتنا",
  "donatePage.subtitle": "كرمك يحدث فرقاً",
  "donatePage.supportMission": "ادعم",
  "donatePage.mission": "رسالتنا",
  "donatePage.donateDesc": "تساعدنا تبرعاتكم على مواصلة خدمتنا ونشر محبة الله.",
  "donatePage.taxDeductible": "جميع التبرعات معفاة من الضرائب",
  "donatePage.giveNow": "تبرع الآن",
  "donatePage.giveMonthly": "تبرع شهرياً",
  "donatePage.recurringGift": "إعداد تبرع متكرر",
  "donatePage.oneTime": "مرة واحدة",
  "donatePage.monthly": "شهرياً",
  "donatePage.monthlyGift": "اختر مبلغاً شهرياً",
  "donatePage.whyMonthly": "لماذا التبرع الشهري؟",
  "donatePage.monthlyImpact": "التبرعات الشهرية توفر دعماً مستقراً يساعدنا على الحفاظ على خدماتنا طوال العام.",
  "donatePage.securePayment": "دفع آمن",
  "donatePage.sslEncrypted": "تشفير SSL",
  "donatePage.taxReceipt": "إيصال ضريبي مقدم",
  "donatePage.ministryPrograms": "برامج الخدمة",
  "donatePage.ministryProgramsDesc": "دعم خدمات العبادة وبرامج الشباب",
  "donatePage.communityOutreach": "التواصل المجتمعي",
  "donatePage.communityOutreachDesc": "مساعدة المحتاجين",
  "donatePage.missionWork": "العمل الإرسالي",
  "donatePage.missionWorkDesc": "نشر الإنجيل حول العالم",
  "donatePage.otherWaysToGive": "طرق أخرى للتبرع",
  "donatePage.giveWithPayPal": "PayPal",
  "donatePage.giveWithPayPalDesc": "تبرع بأمان عبر الإنترنت باستخدام PayPal.",
  "donatePage.openPayPal": "تبرع عبر PayPal",
  "donatePage.registeredCharity": "جمعية خيرية مسجلة",
  "donatePage.charityNumber": "إيصالات رسمية مقدمة للأغراض الضريبية",
  "donatePage.taxReceiptsWillBeIssued": "سيتم إصدار إيصالات ضريبية لجميع التبرعات",
  "donatePage.interacTransfer": "تحويل إنتراك",
  "donatePage.interacDesc": "أرسل تحويلك من حسابك البنكي الكندي.",
  "donatePage.interacEmail": "أرسل إلى",
  "donatePage.interacQuestion": "سؤال الأمان",
  "donatePage.interacAnswer": "الإجابة",
  "donatePage.interacTaxNote": "أدرج الاسم والعنوان والهاتف والبريد للإيصال الضريبي.",
  "donatePage.mailCheck": "إرسال شيك",
  "donatePage.mailCheckDesc": "الشيكات باسم \"كنيسة القديس مينا والبابا كيرلس السادس\".",
  "donatePage.inKindDonations": "تبرعات عينية",
  "donatePage.inKindDonationsDesc": "نقبل التبرعات من السلع والخدمات.",
  "donatePage.paypalSecure": "دفع آمن عبر PayPal",
  "donatePage.close": "إغلاق",
  "donatePage.legacyGiving": "التبرع الموروث",
  "donatePage.legacyGivingDesc": "ضمّن كنيستنا في تخطيط تركتك.",
  "donatePage.bibleVerse": "ليعطِ كل واحد كما نوى في قلبه، لا عن حزن أو اضطرار. لأن الله يحب المعطي المسرور.",
  "donatePage.bibleVerseRef": "رسالة كورنثوس الثانية 9:7",
  "donatePage.selectAmount": "اختر مبلغاً",
  "donatePage.customAmount": "مبلغ مخصص",
  "donatePage.enterAmount": "أدخل المبلغ",

  // Sermons Page
  "sermonsPage.title": "العظات",
  "sermonsPage.subtitle": "رسائل ملهمة من رجال الدين",
  "sermons.loading": "جارٍ تحميل العظات...",
  "sermons.viewAll": "عرض الكل",
  "sermons.watchOnYouTube": "شاهد على يوتيوب",
  "sermons.noVideos": "لا توجد فيديوهات متاحة",

  // Calendar Feasts Data
  "feast.nativity.name": "ميلاد المسيح (عيد الميلاد)",
  "feast.nativity.date": "7 يناير (29 كيهك)",
  "feast.nativity.desc": "الاحتفال بميلاد ربنا ومخلصنا يسوع المسيح في بيت لحم من العذراء مريم.",
  "feast.nativity.significance": "واحدة من أكثر أعياد السنة بهجةً. الميلاد يعلّم تجسد الله وحلول الكلمة فينا ليخلص البشرية.",
  "feast.theophany.name": "الغطاس (الظهور الإلهي)",
  "feast.theophany.date": "19 يناير (11 طوبة)",
  "feast.theophany.desc": "يحِيي ذكرى معمودية يسوع المسيح في نهر الأردن على يد القديس يوحنا المعمدان.",
  "feast.theophany.significance": "تجلّت الثالوث الأقدس بالكمال. تبارك الكنائس القبطية المياه في هذا اليوم.",
  "feast.annunciation.name": "البشارة",
  "feast.annunciation.date": "7 أبريل (29 برمهات)",
  "feast.annunciation.desc": "يبشّر رئيس الملائكة جبرائيل العذراء مريم بأنها ستحبل وتلد ابن الله.",
  "feast.annunciation.significance": "تحتفل بلحظة التجسد حين قالت العذراء: \"ليكن لي كقولك\". تقام قبل تسعة أشهر من الميلاد.",
  "feast.palmSunday.name": "أحد الشعانين",
  "feast.palmSunday.date": "متحرك — الأحد قبل القيامة",
  "feast.palmSunday.desc": "دخول المسيح منتصراً إلى أورشليم واستقبال الجموع بسعف النخيل.",
  "feast.palmSunday.significance": "يفتتح أسبوع الآلام (البصخة)، أكثر أسابيع السنة قداسة. تُبارك سعفات النخيل وتُوزع.",
  "feast.resurrection.name": "القيامة (عيد القيامة / البصخة المقدسة)",
  "feast.resurrection.date": "متحرك — وفق التقويم اليولياني",
  "feast.resurrection.desc": "قيامة ربنا يسوع المسيح المجيدة من بين الأموات في اليوم الثالث.",
  "feast.resurrection.significance": "أعظم وأهم أعياد السنة المسيحية. بعد 55 يوماً من الصوم الكبير تنفجر الكنيسة بالفرح: \"المسيح قام!\"",
  "feast.ascension.name": "صعود الرب",
  "feast.ascension.date": "40 يوماً بعد القيامة (خميس)",
  "feast.ascension.desc": "يصعد المسيح جسدياً إلى السماء بعد أربعين يوماً من قيامته.",
  "feast.ascension.significance": "الصعود يؤكد أن إنسانية المسيح الممجدة جالسة الآن عن يمين الآب.",
  "feast.pentecost.name": "العنصرة (حلول الروح القدس)",
  "feast.pentecost.date": "50 يوماً بعد القيامة (أحد)",
  "feast.pentecost.desc": "يحل الروح القدس على الرسل في العلية على هيئة ألسنة من نار.",
  "feast.pentecost.significance": "العنصرة هي ميلاد الكنيسة. استلم التلاميذ موهبة الروح القدس.",
  "feast.circumcision.name": "ختان الرب",
  "feast.circumcision.date": "14 يناير (6 طوبة)",
  "feast.circumcision.desc": "يحيي ذكرى ختان طفل يسوع في اليوم الثامن بعد ميلاده.",
  "feast.circumcision.significance": "خضع المسيح لشريعة موسى ليكملها عنّا.",
  "feast.presentation.name": "تقدمة الرب في الهيكل",
  "feast.presentation.date": "15 فبراير (8 أمشير)",
  "feast.presentation.desc": "تقدمة طفل يسوع في هيكل أورشليم، بعد أربعين يوماً من ميلاده.",
  "feast.presentation.significance": "عرف سمعان وحنة الطفل المسيح باعتباره المسيح.",
  "feast.holyFamily.name": "دخول العائلة المقدسة إلى مصر",
  "feast.holyFamily.date": "1 يونيو (24 بشنس)",
  "feast.holyFamily.desc": "يحيي ذكرى هروب العائلة المقدسة إلى مصر هرباً من الملك هيرودس.",
  "feast.holyFamily.significance": "لمصر مكانة فريدة في الهوية القبطية: باركت العائلة المقدسة التربة المصرية.",
  "feast.transfiguration.name": "تجلي الرب",
  "feast.transfiguration.date": "19 أغسطس (13 مسرى)",
  "feast.transfiguration.desc": "يتجلى المسيح على جبل التجلي، كاشفاً مجده الإلهي لبطرس ويعقوب ويوحنا.",
  "feast.transfiguration.significance": "التجلي يمنحنا لمحة من طبيعة المسيح الإلهية.",
  "feast.dormition.name": "انتياح العذراء مريم",
  "feast.dormition.date": "22 أغسطس (16 مسرى)",
  "feast.dormition.desc": "يحيي ذكرى انتقال وارتفاع والدة الإله (التيوتوكوس) العذراء مريم.",
  "feast.dormition.significance": "يسبقه صوم السيدة العذراء لمدة 15 يوماً.",
  "feast.crossExaltation.name": "عيد الصليب المقدس",
  "feast.crossExaltation.date": "27 سبتمبر (17 توت)",
  "feast.crossExaltation.desc": "يحيي ذكرى اكتشاف الصليب الحقيقي على يد الإمبراطورة هيلانة عام 326.",
  "feast.crossExaltation.significance": "الصليب هو الرمز المركزي للخلاص.",
  "feast.nayrouz.name": "رأس السنة القبطية (النيروز)",
  "feast.nayrouz.date": "11 سبتمبر (1 توت)",
  "feast.nayrouz.desc": "أول يوم في السنة التقويمية القبطية، ويعرف أيضاً بعيد الشهداء.",
  "feast.nayrouz.significance": "النيروز يكرّم آلاف الشهداء المسيحيين المصريين. البلح والورود الحمراء ترمز لدم الشهداء.",
  "feast.greatLent.name": "الصوم الكبير (الصوم المقدس 55 يوماً)",
  "feast.greatLent.date": "55 يوماً قبل القيامة",
  "feast.greatLent.desc": "أقدس وأهم فترة صيام في السنة القبطية، لتحضير المؤمنين للبصخة المقدسة.",
  "feast.greatLent.significance": "وقت للصلاة المكثفة والصيام والتوبة والتجديد الروحي.",
  "feast.adventFast.name": "صوم الميلاد",
  "feast.adventFast.date": "25 نوفمبر – 6 يناير (43 يوماً)",
  "feast.adventFast.desc": "صوم 43 يوماً لتحضير المؤمنين لميلاد المسيح.",
  "feast.adventFast.significance": "وقت للتحضير الروحي والتأمل في تجسد الكلمة.",
  "feast.apostlesFast.name": "صوم الرسل",
  "feast.apostlesFast.date": "بعد العنصرة — مدة متغيرة",
  "feast.apostlesFast.desc": "صوم تكريماً للرسل القديسين، يبدأ يوم الاثنين بعد أحد العنصرة.",
  "feast.apostlesFast.significance": "يحيي ذكرى صيام الرسل بعد نزول الروح القدس. ينتهي في 12 يوليو.",
  "feast.stMaryFast.name": "صوم السيدة العذراء",
  "feast.stMaryFast.date": "7–21 أغسطس (15 يوماً)",
  "feast.stMaryFast.desc": "صوم 15 يوماً تكريماً للعذراء مريم، سابق عيد انتياحها.",
  "feast.stMaryFast.significance": "يعبّر هذا الصوم عن حب الكنيسة العميق للعذراء مريم.",
  "feast.nineveh.name": "صوم نينوى",
  "feast.nineveh.date": "3 أيام — الاثنين إلى الأربعاء، 3 أسابيع قبل الصوم الكبير",
  "feast.nineveh.desc": "صوم ثلاثة أيام لذكرى توبة أهل نينوى بكرازة النبي يونس.",
  "feast.nineveh.significance": "يذكّرنا برحمة الله وقوة التوبة.",
  "feast.wedFri.name": "صوم الأربعاء والجمعة الأسبوعي",
  "feast.wedFri.date": "كل أربعاء وجمعة طوال السنة",
  "feast.wedFri.desc": "تصوم الكنيسة القبطية كل أربعاء وجمعة طوال السنة.",
  "feast.wedFri.significance": "الأربعاء يحيي خيانة المسيح. الجمعة يحيي الصلب. يُمارس بالامتناع عن المنتجات الحيوانية حتى الساعة التاسعة.",

  // Resources Page
  "resourcesPage.title": "الموارد",
  "resourcesPage.subtitle": "النماذج والمكتبات والأدوات لمجتمع كنيستنا",
  "resourcesPage.quickAccess": "وصول سريع",
  "resourcesPage.churchForms": "نماذج الكنيسة",
  "resourcesPage.formsDesc": "الوصول إلى النماذج الرسمية للأسرار والفعاليات والعضوية",
  "resourcesPage.membershipForm": "نموذج العضوية",
  "resourcesPage.membershipFormDesc": "انضم رسمياً إلى مجتمع رعيتنا",
  "resourcesPage.baptismForm": "نموذج المعمودية",
  "resourcesPage.baptismFormDesc": "اطلب سر المعمودية المقدسة",
  "resourcesPage.engagementForm": "نموذج الخطوبة",
  "resourcesPage.engagementFormDesc": "سجل حفل خطوبتك",
  "resourcesPage.weddingForm": "نموذج الزواج",
  "resourcesPage.weddingFormDesc": "جدول وسجل حفل زواجك",
  "resourcesPage.funeralForm": "نموذج الجنازة",
  "resourcesPage.funeralFormDesc": "ترتيب خدمات الجنازة والتأبين",
  "resourcesPage.eventBooking": "حجز الفعاليات",
  "resourcesPage.eventBookingDesc": "احجز قاعات ومساحات الكنيسة لفعالياتك",
  "resourcesPage.accessForm": "الوصول إلى النموذج",
  "resourcesPage.dioceseService": "خدمة الإيبارشية",
  "resourcesPage.copticAnswersTitle": "الإجابات القبطية الأرثوذكسية",
  "resourcesPage.copticAnswersDesc": "مورد شامل من إيبارشية أوتاوا ومونتريال وشرق كندا يقدم إجابات على الأسئلة الشائعة حول الإيمان القبطي الأرثوذكسي.",
  "resourcesPage.faithQuestions": "أسئلة الإيمان",
  "resourcesPage.faithQuestionsDesc": "احصل على إجابات واضحة للأسئلة الشائعة حول العقيدة القبطية",
  "resourcesPage.theologicalTopics": "المواضيع اللاهوتية",
  "resourcesPage.theologicalTopicsDesc": "استكشف مواضيع لاهوتية معمقة يشرحها رجال ديننا",
  "resourcesPage.videoResources": "موارد الفيديو",
  "resourcesPage.videoResourcesDesc": "شاهد مقاطع تعليمية عن الإيمان والتقاليد القبطية",
  "resourcesPage.visitCopticAnswers": "زيارة الإجابات القبطية الأرثوذكسية",
  "resourcesPage.learnGrow": "تعلم وانمو",
  "resourcesPage.librariesTitle": "المكتبات الروحية",
  "resourcesPage.librariesDesc": "استكشف مجموعتنا من الكتب والترانيم ومواد الدراسة",
  "resourcesPage.popeShenoudaBooks": "كتب البابا شنودة الثالث",
  "resourcesPage.popeShenoudaBooksDesc": "الكتابات الروحية وتعاليم البابا شنودة الثالث",
  "resourcesPage.releaseOfSpirit": "تحرير الروح",
  "resourcesPage.lifeOfFaith": "حياة التوبة والطهارة",
  "resourcesPage.contemplations": "تأملات في المزامير",
  "resourcesPage.wordsOfBenefit": "كلمات الفائدة الروحية",
  "resourcesPage.hymnalResources": "موارد الألحان",
  "resourcesPage.hymnalResourcesDesc": "كتب الألحان القبطية وموارد الموسيقى الليتورجية",
  "resourcesPage.copticHymnsBook": "كتاب الألحان القبطية",
  "resourcesPage.tasbehaLyrics": "كلمات التسبحة",
  "resourcesPage.liturgyResponses": "قداس القديس باسيليوس",
  "resourcesPage.seasonalHymns": "ألحان موسمية",
  "resourcesPage.bibleStudyMaterials": "مواد دراسة الكتاب المقدس",
  "resourcesPage.bibleStudyMaterialsDesc": "أدلة الدراسة والتفاسير لدراسة الكتاب المقدس",
  "resourcesPage.oldTestament": "دراسة العهد القديم",
  "resourcesPage.newTestament": "دراسة العهد الجديد",
  "resourcesPage.psalmsCommentary": "تفسير المزامير",
  "resourcesPage.churchFathers": "آباء الكنيسة",
  "resourcesPage.sundaySchoolCurriculum": "منهج مدارس الأحد",
  "resourcesPage.sundaySchoolCurriculumDesc": "مواد تكوين الإيمان المناسبة لكل عمر",
  "resourcesPage.preKMaterials": "مواد ما قبل الروضة",
  "resourcesPage.elementaryLessons": "دروس المرحلة الابتدائية",
  "resourcesPage.youthStudies": "دراسات الشباب",
  "resourcesPage.adultFormation": "تكوين البالغين",
  "resourcesPage.brandAssets": "أصول العلامة التجارية",
  "resourcesPage.logoAndFonts": "الشعار والخطوط",
  "resourcesPage.logoAndFontsDesc": "شعارات الكنيسة الرسمية والخطوط القبطية للمطبوعات",
  "resourcesPage.churchLogo": "شعار الكنيسة",
  "resourcesPage.fullColorLogo": "شعار بالألوان الكاملة",
  "resourcesPage.primaryUse": "الاستخدام الأساسي — الخلفيات الفاتحة",
  "resourcesPage.downloadPNG": "تحميل PNG",
  "resourcesPage.whiteLogo": "شعار أبيض",
  "resourcesPage.darkBackgrounds": "للخلفيات الداكنة",
  "resourcesPage.monochromeLogo": "شعار أحادي اللون",
  "resourcesPage.printMaterials": "مواد الطباعة",
  "resourcesPage.iconOnly": "الأيقونة فقط",
  "resourcesPage.outlineLightLogo": "مخطط فاتح",
  "resourcesPage.outlineLightDesc": "للخلفيات الداكنة",
  "resourcesPage.outlineDarkLogo": "مخطط داكن",
  "resourcesPage.outlineDarkDesc": "للخلفيات الفاتحة",
  "resourcesPage.copticFonts": "الخطوط القبطية",
  "resourcesPage.copticFontsTitle": "حزمة الخطوط القبطية الرسمية",
  "resourcesPage.copticFontsSubtitle": "لنظامي Windows و Mac",
  "resourcesPage.copticFontsDesc": "حمّل الخطوط القبطية الرسمية المستخدمة في مطبوعاتنا الليتورجية وموارد مدارس الأحد.",
  "resourcesPage.downloadFontPack": "تحميل حزمة الخطوط (.zip)",
  "resourcesPage.installationGuide": "دليل التثبيت",
  "resourcesPage.installationGuideTitle": "كيفية تثبيت الخطوط القبطية",
  "resourcesPage.installationGuideWindows": "Windows",
  "resourcesPage.installationGuideMac": "Mac",
  "resourcesPage.installationGuideStep1": "حمّل ملف ZIP لحزمة الخطوط",
  "resourcesPage.installationGuideStep2": "استخرج/فك ضغط الملف المحمّل",
  "resourcesPage.installationGuideStep3Win": "انقر بزر الأيمن على كل ملف .ttf أو .otf ← تثبيت",
  "resourcesPage.installationGuideStep3Mac": "انقر نقراً مزدوجاً على كل ملف .ttf أو .otf ← تثبيت الخط",
  "resourcesPage.installationGuideStep4": "أعد تشغيل تطبيقك (Word، إلخ) لاستخدام الخطوط",
  "resourcesPage.sampleText": "نموذج نص قبطي — المسيح قام",
  "resourcesPage.fontsIncluded": "الخطوط المضمنة في هذه الحزمة:",
  "resourcesPage.usageGuidelines": "إرشادات الاستخدام",
  "resourcesPage.usageGuidelinesDesc": "هذه الأصول للاستخدام الرسمي للكنيسة فقط. يرجى الحفاظ على سلامة الشعارات واستخدام الخطوط المعتمدة في جميع المطبوعات.",
  "resourcesPage.needHelp": "تحتاج مساعدة؟",
  "resourcesPage.needHelpDesc": "إذا كان لديك أسئلة حول النماذج أو الموارد أو تحتاج مساعدة، فريقنا هنا للمساعدة.",

  // Language
  "language": "اللغة",

  // Weekly Calendar Component
  "weeklyCalendar.servicesEvents": "جدول الخدمات والفعاليات",
  "weeklyCalendar.subscribe": "اشتراك",
  "weeklyCalendar.googleCalendar": "تقويم جوجل",
  "weeklyCalendar.today": "اليوم",
  "weeklyCalendar.thisWeekSchedule": "جدول هذا الأسبوع",
  "weeklyCalendar.viewAllWeek": "عرض كل الأسبوع",
  "weeklyCalendar.loadingEvents": "جارٍ تحميل الفعاليات...",
  "weeklyCalendar.noEvents": "لا توجد فعاليات مجدولة",
  "weeklyCalendar.events": "فعاليات",
  "weeklyCalendar.liturgy": "قداس",
  "weeklyCalendar.feast": "عيد",
  "weeklyCalendar.fast": "صوم",
  "weeklyCalendar.meeting": "اجتماع",
  "weeklyCalendar.youth": "شباب",
  "weeklyCalendar.subscribeShort": "اشتراك",
  "weeklyCalendar.calendar": "التقويم",
};

export default translations;